// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"4f032016","249":"0d75a070","497":"6ff79efe","604":"9df73ecc","788":"514fe5c2","825":"ab81eeca","848":"1d32700a","879":"81bb46a7"}[chunkId] + ".chunk.js";
};